import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c973732"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "temporary-exhibition-register" }
const _hoisted_2 = { class: "locales" }
const _hoisted_3 = {
  key: 0,
  class: "locales-dropdown"
}
const _hoisted_4 = { class: "locales-form" }
const _hoisted_5 = {
  action: "/change-locale",
  method: "POST",
  ref: "localeFormRef"
}
const _hoisted_6 = {
  class: "form choose-password-form",
  method: "post"
}
const _hoisted_7 = { class: "confirmation" }
const _hoisted_8 = { class: "checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_locales_dropdown = _resolveComponent("locales-dropdown")!
  const _component_input_form = _resolveComponent("input-form")!
  const _component_password_rating = _resolveComponent("password-rating")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_checkbox_element = _resolveComponent("checkbox-element")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: _normalizeClass(["current", { '-open': _ctx.showLocales }]),
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showLocales = true), ["prevent"]))
      }, _toDisplayString(_ctx.locale.toUpperCase()), 3)
    ]),
    (_ctx.showLocales)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_locales_dropdown, {
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLocales = false)),
            onChangedLocale: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLocale($event)))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", _hoisted_5, null, 512)
    ]),
    _createElementVNode("form", _hoisted_6, [
      _createVNode(_component_input_form, {
        type: "tel",
        class: "tel",
        label: _ctx.$t('staff.choosePassword.view.mobile'),
        name: "phone",
        required: "",
        modelValue: _ctx.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phone) = $event)),
        "error-message": _ctx.invalidPhoneNumberMessage
      }, null, 8, ["label", "modelValue", "error-message"]),
      _createVNode(_component_input_form, {
        type: "text",
        class: "tel",
        label: _ctx.$t('staff.profile.firstName'),
        name: "firstname",
        required: "",
        modelValue: _ctx.firstname,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.firstname) = $event)),
        autocomplete: "given-name"
      }, null, 8, ["label", "modelValue"]),
      _createVNode(_component_password_rating, {
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password) = $event)),
        class: "rating"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_input_form, {
          type: "password",
          name: "password-confirmation",
          label: _ctx.$t('staff.choosePassword.view.passwordConfirmation'),
          modelValue: _ctx.passwordConfirmation,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
          isPW: "",
          required: "",
          autocomplete: "new-password"
        }, null, 8, ["label", "modelValue"]),
        _createElementVNode("span", {
          class: _normalizeClass(["error copy -font-size-10 -font-weight-500", { '-show': _ctx.showPasswordsNotMatching }])
        }, _toDisplayString(_ctx.$t('staff.choosePassword.view.passwordsMismatch')), 3)
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["error copy -font-size-14 -font-weight-500", { '-show': _ctx.hasGeneralError }])
      }, _toDisplayString(_ctx.$t('staff.choosePassword.view.couldNotRegister')), 3),
      _createVNode(_component_app_button, {
        class: "button -primary",
        disabled: !_ctx.canSubmit,
        label: _ctx.$t('staff.choosePassword.view.participate'),
        type: "submit"
      }, null, 8, ["disabled", "label"]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_checkbox_element, {
          modelValue: _ctx.rememberMe,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rememberMe) = $event)),
          name: "rememberme",
          label: _ctx.$t('staff.choosePassword.view.rememberMe'),
          class: "checkbox"
        }, null, 8, ["modelValue", "label"])
      ])
    ])
  ]))
}